import styled from 'styled-components'

const LinkStyled = styled.a`
  display: inline-flex;
  text-decoration: underline;

  &:active,
  &:visited,
  &:link {
    color: #444f56;
  }

  &:hover {
    color: #ff1945 !important;
    text-decoration: none;
    transition: color .2s ease-in;
    cursor: pointer;
  }
`

export default LinkStyled
